module.exports = __webpack_public_path__ + "product_tag-animated_image.78cdfa5d151d267af1696b37ba393f44.gif";